import { useTranslation } from 'react-i18next';
import { Box, Typography } from '@mui/material';

import { date } from '@/utilities/dateUtils';

import type { RefuelsQueryResultProps } from '../../types/RefuelsQueryResultProps.types';

import { RefuelSummaryBody, RefuelSummaryCard, RefuelSummaryCardContent } from './RefuelSummary.styles';

type RefuelSummaryProps = Pick<RefuelsQueryResultProps, 'result'>;

export function RefuelSummary({ result }: RefuelSummaryProps) {
  const { t } = useTranslation();

  const totalRefuelAmount = result?.refuels.reduce((sum, refuel) => sum + refuel.fillAmount, 0);

  return (
    <Box>
      <RefuelSummaryCard>
        <RefuelSummaryCardContent data-qa-element-id="refuel_summary_panel">
          <Typography variant="h5" component="div">
            <Box component="span" data-qa-element-id="refuel_summary_panel_title">
              {t('refuels.aggregatedDataSort') + ' ('}
              {result?.refuels.length ?? 0} {`${t('refuels.summary.refueling').toLowerCase()})`}
            </Box>
          </Typography>
          <Typography variant="body2" component="div">
            <RefuelSummaryBody direction="row" gap={2}>
              <Box>
                {result && (
                  <>
                    <Typography variant="body2" data-qa-element-id="date_intarval_label">
                      {t('refuels.summary.dateRange')}:
                    </Typography>
                    <Typography variant="body2" data-qa-element-id="fuel_fillings_label">
                      {t('refuels.title')}:
                    </Typography>
                  </>
                )}
              </Box>
              <Box>
                {result && (
                  <>
                    <Typography variant="subtitle2" data-qa-element-id="refuel_summary_date_interval">
                      {date(result.dates.from, t)} - {date(result.dates.to, t)}
                    </Typography>
                    <Typography variant="subtitle2" color="secondary" data-qa-element-id="refuel_summary_fill_amount">
                      {totalRefuelAmount?.toFixed(1)} L
                    </Typography>
                  </>
                )}
              </Box>
            </RefuelSummaryBody>
          </Typography>
        </RefuelSummaryCardContent>
      </RefuelSummaryCard>
    </Box>
  );
}
